import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { ExclamationSpeechIcon } from '../assets/icons/ExclamationSpeech';
import { gaEvent, gaPageView } from '../services/ga/ga';
import {
  formApplianceName,
  formCategoryName,
  store,
  useApplianceFormData,
  useAppState,
  useConfirmation,
  useGaEventData,
  useUrlParams,
} from '../store/store';
import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { getSystemCode } from '../utils/getSystemCode';
import { capturePostHogEvent } from '../services/posthog/capture';

export function ErrorPage() {
  const { session } = useAppState();
  const urlParams = useUrlParams();
  const systemCode = getSystemCode(urlParams?.rs);
  const formData = useApplianceFormData();
  const confirmation = useConfirmation();
  const gaEventData = useGaEventData();
  const posthog = usePostHog();
  const offerPrice = gaEventData?.netFirstPaymentAmount;
  const applianceName = formApplianceName.get();
  const applianceCategory = formCategoryName.get();

  useEffect(() => {
    gaPageView({
      pagename: 'generic-error',
      category: 'registration-pages',
      type: 'STANDARD',
      appSessionID: session?.id,
      regSystemCode: systemCode,
      applianceName,
      applianceCategory,
      appliancePurchaseCost: formData.purchasePrice?.purchasePrice,
      appliancePurchaseDate: formData.purchaseDate?.purchaseDate,
      modelNumberDetail: formData.modelSerial?.modelNumber,
      serialNumberDetail: formData.modelSerial?.serialNumber,
      serialNumber: formData.modelSerial?.serialNumber ? 'provided' : 'not provided',
      modelNumber: formData.modelSerial?.modelNumber ? 'provided' : 'not provided', // report "provided" if user submitted the serial number of the appliance, report "not provided" if they do not
      offerPrice,
      planNumber: confirmation?.purchaseData?.planNumber,
    });
  }, []);

  const handlePhoneNumber = () => {
    gaEvent({
      event: 'genericGAEvent',
      eventCategory: 'appliance details form USA',
      eventAction: 'Generic Error page',
      eventLabel: 'Phone Number clicked',
      pagename: 'generic-error',
      category: 'registration-pages',
      type: 'STANDARD',
      appSessionID: session?.id,
      regSystemCode: systemCode,
      applianceName,
      applianceCategory,
      appliancePurchaseCost: formData.purchasePrice?.purchasePrice,
      appliancePurchaseDate: formData.purchaseDate?.purchaseDate,
      modelNumberDetail: formData.modelSerial?.modelNumber,
      serialNumberDetail: formData.modelSerial?.serialNumber,
      serialNumber: formData.modelSerial?.serialNumber ? 'provided' : 'not provided',
      modelNumber: formData.modelSerial?.modelNumber ? 'provided' : 'not provided', // report "provided" if user submitted the serial number of the appliance, report "not provided" if they do not
      offerPrice,
      planNumber: confirmation?.purchaseData?.planNumber,
    });

    capturePostHogEvent(posthog, 'error-phone-clicked', store.get());
  };

  return (
    <div className="flex flex-col justify-center items-start text-left px-4 my-8 gap-4 md:items-center md:text-center">
      <ExclamationSpeechIcon />
      <h1 className="text-3xl font-semibold">Sorry, something’s not right.</h1>
      <p>It looks like there’s been a technical issue but we’re working to fix it.</p>
      <p>
        <strong>Please try again later or call us to complete your registration:</strong>
      </p>
      <TextLink onClick={handlePhoneNumber} href="tel:+1-833-552-2314">
        +1 833-552-2314
      </TextLink>
    </div>
  );
}
